export class UnhandledErrorMessage {
}